export class UnhandledErrorMessage {
}